import { Outlet, useLocation } from "react-router-dom"
import { useEffect, useRef } from "react"
import { TopSky } from "./sky/TopSky"

/**
 * Text column width, px. Posts are long-form serif, so they get room for
 * about 65 characters a line; the home page keeps its compact card width.
 */
const COLUMN = { page: 440, post: 512 } as const

// ============================================================================
// Main Component
// ============================================================================

export function MainLayout() {
  const location = useLocation()
  const mainRef = useRef<HTMLElement>(null)
  const lastPathnameRef = useRef(location.pathname)
  const column = location.pathname.startsWith("/blog/") ? COLUMN.post : COLUMN.page

  // On client-side navigation, start the new page at the top and move focus
  // to it, so keyboard and screen-reader users land on the new content
  // instead of a removed link. The first render keeps the browser's focus.
  useEffect(() => {
    if (lastPathnameRef.current === location.pathname) return
    lastPathnameRef.current = location.pathname
    window.scrollTo({ top: 0, behavior: "instant" })
    mainRef.current?.focus({ preventScroll: true })
  }, [location.pathname])

  return (
    <div className="relative min-h-svh">
      <TopSky column={column} />
      <main
        ref={mainRef}
        tabIndex={-1}
        style={{ maxWidth: column }}
        className="relative mx-auto w-full px-6 py-12 outline-hidden sm:py-16"
      >
        <div key={location.pathname} className="content-enter">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
